module.exports = __webpack_public_path__ + "images/spinner-16x16-light-8a1bfd29a8b8e31de99e3265a36cd39d.gif";